import { type FC } from 'react';
import { Folder, Images } from 'lucide-react';
import kebabCase from 'lodash/kebabCase';
import { Label, LabelVariants } from '@/components/ui/label';
import { Separator } from '@/components/ui/separator';
import { Node } from '@/components/inspector/node';
import { type Ancestors } from '@/types/tree';
import { useTranslations } from 'next-intl';

interface NodeLocationsProps {
  ancestors?: Ancestors;
  albumPaths?: Array<string>;
}

export const NodeLocations: FC<NodeLocationsProps> = ({ ancestors, albumPaths }) => {
  const tLocations = useTranslations('inspector.locations');

  if ((!ancestors || ancestors?.length === 0) && (!albumPaths || albumPaths.length === 0)) {
    return null;
  }

  const parentPath =
    ancestors && ancestors.length > 0 ? ancestors.map((ancestor) => ancestor.name).join('/') : undefined;

  return (
    <>
      <Separator className="bg-ui-void-gap!" />
      <div className="flex flex-col space-y-2 p-3">
        {parentPath && (
          <div className="space-y-1.5">
            <Label variant={LabelVariants.INSPECTOR_SECTION}>{tLocations('parentFolder')}</Label>
            <Node icon={Folder} iconClassName="stroke-folder-color" path={parentPath} />
          </div>
        )}

        {albumPaths && albumPaths.length > 0 && (
          <div className="space-y-1.5">
            <Label variant={LabelVariants.INSPECTOR_SECTION}>{tLocations('albums')}</Label>
            <div className="flex flex-col space-y-2">
              {albumPaths.map((path) => (
                <Node icon={Images} iconClassName="stroke-album-color" path={path} key={kebabCase(path)} />
              ))}
            </div>
          </div>
        )}
      </div>
      <Separator className="bg-ui-void-gap!" />
    </>
  );
};
